module.exports = __webpack_public_path__ + "img/RTMKlik_favicon_curve.9d6217b5.png";